module.exports = function() {
  return new Worker(__webpack_public_path__ + "28bf5a73b8bf86b44009.worker.js");
};